/**
 * Utility functions for handling GraphQL errors
 */

/**
 * Checks if a GraphQL error is of a specific type by examining the error extensions
 * @param error - The error object from Apollo Client
 * @param errorType - The error type to check for (e.g., 'QuietValidationError')
 * @returns true if the error is of the specified type
 */
export const isGraphQLErrorOfType = (error: any, errorType: string): boolean => {
  return error?.graphQLErrors?.some((gqlError: any) => gqlError.extensions?.errorType === errorType);
};

/**
 * Checks if a GraphQL error is a QuietValidationError
 * @param error - The error object from Apollo Client
 * @returns true if the error is a QuietValidationError
 */
export const isQuietValidationError = (error: any): boolean => {
  return isGraphQLErrorOfType(error, 'QuietValidationError');
};
